export default "__VITE_ASSET__970f24b6__"